import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'delivery-events-tab-2-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './delivery-events-tab-2.part.html',
})
export class DeliveryEventsTab2Part {
}
